import script from "./BotToken.vue?vue&type=script&setup=true&lang=ts"
export * from "./BotToken.vue?vue&type=script&setup=true&lang=ts"

import "./BotToken.vue?vue&type=style&index=0&id=0c440228&scoped=true&lang=css"

import exportComponent from "/home/dima/Work/pioneer-lk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c440228"]])

export default __exports__